import React from 'react';

//Hmm

export type NavigationContextMenuContextData = {
    toggle(open: boolean): void;
    open: boolean;
    // setContainer(container: HTMLElement): void;
};

const NavigationContextMenuContext = React.createContext<NavigationContextMenuContextData>({
    toggle: () => {},
    open: false,
    // setContainer: () => {},
});

export default NavigationContextMenuContext;

